export const API = {
    BASE_URL: process.env.REACT_APP_DEV ? process.env.REACT_APP_API_BASE_URL_DEV+"/api" : null,
    LOCAL_BASE_URL: "http://localhost:3000/",
    HIT_DUMMY_URL: process.env.REACT_APP_HIT_DUMMY_API,
    ADMIN_AUTH_SELLER_PANEL_URL: `${process.env.REACT_APP_SELLER_BASE_URL}/admin-authentication`,
    ADMIN_AUTH_SELLER_PANEL_URL_DEMO: `${process.env.REACT_APP_SELLER_BASE_URL_DEMO}/admin-authentication`,
    SSE_API_PATH: `${process.env.REACT_APP_API_BASE_URL_DEV}/sse/events/notification`,
};